<template>
  <vl-properties-list>
    <vl-properties-label>{{ $t('productentity.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('productentity.detail.code') }}</vl-properties-label>
    <vl-properties-data>{{ detail.code }}</vl-properties-data>
    <vl-properties-label>{{ $t('productentity.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('productentity.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ detail.description }}</vl-properties-data>
    <vl-properties-label>{{ $t('productentity.detail.model') }}</vl-properties-label>
    <vl-properties-data> <PbsEntityRouterLink type="entityModel" :detail="detail.model" /> </vl-properties-data>
    <vl-properties-label v-if="!isCodeListOrTable">{{ $t('productentity.detail.crs') }}</vl-properties-label>
    <vl-properties-data v-if="!isCodeListOrTable">{{ detail.crs.name }}</vl-properties-data>
  </vl-properties-list>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { ProductEntityDetailDto } from '@/api/backoffice/clients';
import PbsEntityRouterLink from '@/components/PbsEntityRouterLink.vue';
import { ENUM_EntityTypes } from '@/modules/configuration/common';

const props = defineProps<{
  detail: ProductEntityDetailDto;
}>();

const detail = computed((): ProductEntityDetailDto => {
  return props.detail;
});

const isCodeListOrTable = computed((): boolean => {
  return detail.value?.model?.entityTypeName == ENUM_EntityTypes.CodeList.name || detail.value?.model?.entityTypeName == ENUM_EntityTypes.Table.name;
});

</script>
